/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OfferInName
 */
export interface OfferInName {
    /**
     * 
     * @type {string}
     * @memberof OfferInName
     */
    name: string;
}

export function OfferInNameFromJSON(json: any): OfferInName {
    return OfferInNameFromJSONTyped(json, false);
}

export function OfferInNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): OfferInName {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function OfferInNameToJSON(value?: OfferInName | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}


